import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, listupdater, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import CutomerDetailPop from '../../component/CutomerDetailPop';

import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';
import Contractwrite from '../../component/Contractwrite';

import * as APIS from "../../utils/service";
import { getMemberinfo, hpHypen, numFormat, useIntersectionObserver } from "../../utils/utils";

// 팝업 컴포넌트
import MainPopup from '../main/MainPopup';
export default function Contract({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const target = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    const buttonStyle = {
        width: 200,
        fontSize: 14,
        fontWeight: 700,
        minHeight: 40
    }
    const { listupdate } = useSelector(s => s.popupReducer);
    const [memberinfos, setmemberinfos] = useState('');
    let statusArrs = [];
    configdata?.consts?.contractStatusConsts?.map((x, i) => {
        if (x?.idx * 1 === 99) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'no', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 1) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 2) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 3) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx });
        }
    });
    const statusName = statusArrs;

    const [selectorderby, setselectorderby] = useState('0');
    const [contractIdx, setcontractIdx] = useState(null);

    const [detailwrite, setdetailwrite] = useState(false);
    const [contract_list, setcontract_list] = useState([]);

    const [productlistTh, setproductlistTh] = useState([
        { key: 'status', viewernames: 'set', winsize: 100 },
        { key: 'contractcode', viewernames: '계약번호', winsize: 80 },
        { key: '계약일', viewernames: '계약일', winsize: 80 },
        { key: '중도금1', viewernames: '중도금1', winsize: 80 },
        { key: '중도금2', viewernames: '중도금2', winsize: 80 },
        { key: '잔금일', viewernames: '잔금일', winsize: 80 },
        { key: '계약종류', viewernames: '계약종류' },
        { key: '거래당사자', viewernames: '거래당사자/연락처', winsize: 220 },
        { key: 'sell_type', viewernames: '형태' },
        { key: '거래가격', viewernames: '거래가격', winsize: 170 },
        { key: '소재지', viewernames: '소재지', winsize: 300 },
        { key: '동호', viewernames: '동/호' },
        { key: 'mediation_option', viewernames: '공동여부' },
    ]);
    const [productlistTd, setproductlistTd] = useState([]);
    const [saveproductlistTd, setsaveproductlistTd] = useState([]);
    const [week, setweek] = useState(moment().subtract('1', 'week').day(0).format());
    const [popupShow, setpopupShow] = useState(false);
    const [popupTitle, setpopupTitle] = useState('');
    const [popupType, setpopupType] = useState(1);

    const [page, setPage] = useState(0);
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });

    useEffect(() => {
        console.log(memberinfos);
    }, [memberinfos]);

    useEffect(() => {
        if (listupdate === true) {
            dispatch(listupdater({ listupdate: false }));
            listopen();
        }
    }, [listupdate]);

    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
        getlists();
    }, []);
    const getlists = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            weekstart: moment(week).format('YYYY-MM-DD'),
            weekend: moment(week).add(6, 'days').format('YYYY-MM-DD'),
            types: 'contract'
        }
        //console.log("sendersendersender", sender);
        APIS.postData('/v1/compony/typedashbord', sender).then(({ data }) => {
            if (data) {
                const {
                    items, customers, blacks, componyblacks, mycomponymembers, allmembers, stayitemcklists, staycustomercklists,
                    company_news_lists, contract_lists, meetings, customeralls, crewlists, itembeforemonths, customerbeforemonths,
                    contractbeforemonths, fincustomers, realdatas, posdatas, statlists, companyUserCount, areaUserCount,
                    outsideCount
                } = data;
                let contractsetlist = [];
                contract_lists?.map((x, i) => {
                    //console.log(x);
                    let inputArrData = JSON?.parse(x?.contract);
                    let contractDate = inputArrData?.find(item => item?.keys === '부동산임대차인도일년')?.values + "-" + inputArrData?.find(item => item?.keys === '부동산임대차인도일월')?.values + "-" + inputArrData?.find(item => item?.keys === '부동산임대차인도일일')?.values;
                    let addtwoyearsDate = moment(contractDate).format('YYYY-MM-DD');
                    let durations = moment.duration(moment().diff(addtwoyearsDate)).asDays();
                    console.log(x, contractDate, durations, Math.floor(durations));
                    // contractsetlist.push({ 
                    //     durations: parseInt(durations),
                    //     dates: moment(contractDate).add(2, 'y').format('M.DD'), 
                    //     stickers: inputArrData?.find(item => item?.keys === '건물용도')?.values, 
                    //     subjects: inputArrData?.find(item => item?.keys === '소재지')?.values
                    // });
                    x.durations = durations.toFixed(0);
                    x.dates = moment(contractDate).add(2, 'y').format('M.DD');
                    x.stickers = inputArrData?.find(item => item?.keys === '건물용도')?.values;
                    x.subjects = inputArrData?.find(item => item?.keys === '소재지')?.values;
                    contractsetlist.push(x);
                })
                setcontract_list(contractsetlist);
            }
        }).catch(({ response }) => {
            console.log(response);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const [orContractList, setorContractList] = useState([])
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/contract/list', sender).then(({ data }) => {
            if (data) {
                let tdlist = [];
                let now = moment(new Date());
                setorContractList(data);
                data?.map((x, i) => {
                    let pushData = {};
                    let inputArrData = JSON?.parse(x?.contract);
                    //console.log("inputArrData", inputArrData);
                    productlistTh?.map((x2, i2) => {

                        if (x2?.key === 'contractcode') {
                            pushData[x2?.key] = ('0000000' + x?.idx).slice(-7);
                        } else if (x2?.key === 'status') {
                            pushData[x2?.key] = statusName?.find(item => item?.idx * 1 === x[x2?.key] * 1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                            pushData['statusname'] = statusName?.find(item => item?.idx * 1 === x[x2?.key] * 1)?.title;
                        } else if (x2?.key === '계약일') {
                            let contractDate = inputArrData?.filter(item => (item?.keys === '날인일년' || item?.keys === '날인일월' || item?.keys === '날인일'))?.map(item => item.values)?.join(".");
                            let ordercontractDate = inputArrData?.filter(item => (item?.keys === '날인일년' || item?.keys === '날인일월' || item?.keys === '날인일'))?.map(item => item.values)?.join("");
                            pushData[x2?.key] = moment(contractDate).format('YY.MM.DD');
                            pushData['ordercontractDate'] = ordercontractDate * 1;
                        } else if (x2?.key === '중도금1') {
                            let middleprice = inputArrData?.find(item => item?.keys === '중도금')?.values[0]?.values[0]?.values;
                            //console.log(middleprice);
                            pushData[x2?.key] = numFormat(middleprice);
                            pushData['ordermiddleprice1'] = middleprice * 1;
                        } else if (x2?.key === '중도금2') {
                            let middleprice2 = inputArrData?.find(item => item?.keys === '중도금')?.values[1]?.values[0]?.values;
                            pushData[x2?.key] = numFormat(middleprice2);
                            pushData['ordermiddleprice2'] = middleprice2 * 1;
                        } else if (x2?.key === '잔금일') {
                            let endprice = inputArrData?.find(item => item?.keys === '잔금')?.values;
                            pushData[x2?.key] = numFormat(endprice);
                            pushData['ordermiddleprice2'] = endprice * 1;

                            let contractDate = inputArrData?.filter(item => (item?.keys === '잔금년' || item?.keys === '잔금월' || item?.keys === '잔금일'))?.map(item => item.values)?.join(".");
                            let ordercontractDate = inputArrData?.filter(item => (item?.keys === '잔금년' || item?.keys === '잔금월' || item?.keys === '잔금일'))?.map(item => item.values)?.join("");
                            pushData[x2?.key] = moment(contractDate).format('YY.MM.DD');
                            pushData['orderendtDate'] = ordercontractDate * 1;

                        } else if (x2?.key === '계약종류') {
                            pushData[x2?.key] = x?.category;
                        } else if (x2?.key === '거래당사자') {
                            let names = inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.values[4]?.values;
                            let phones = inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.values[3]?.values;
                            let names2 = inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.values[4]?.values;
                            let phones2 = inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.values[3]?.values;
                            if (x?.sell_type === '매매') {
                                pushData[x2?.key] = "매도 " + names + " " + hpHypen(phones) + "\n매수 " + names2 + " " + hpHypen(phones2);
                            } else {
                                pushData[x2?.key] = "임대 " + names + " " + hpHypen(phones) + "\n임차 " + names2 + " " + hpHypen(phones2);
                            }
                        } else if (x2?.key === '거래가격') {
                            let viewprice = inputArrData?.find(item => item?.keys === '매매대금')?.values * 1;
                            if (x?.sell_type === '매매') {
                                pushData[x2?.key] = numFormat(viewprice);
                            } else if (x?.sell_type === '전세') {
                                viewprice = inputArrData?.find(item => item?.keys === '보증금')?.values * 1;
                                pushData[x2?.key] = numFormat(viewprice);
                            } else {
                                viewprice = inputArrData?.find(item => item?.keys === '보증금')?.values * 1;
                                let viewprice2 = inputArrData?.find(item => item?.keys === '차임')?.values * 1;
                                pushData[x2?.key] = numFormat(viewprice) + "/" + numFormat(viewprice2);
                            }
                        } else if (x2?.key === '소재지') {
                            pushData[x2?.key] = inputArrData?.find(item => item?.keys === '소재지')?.values;
                        } else if (x2?.key === '동호') {
                            pushData[x2?.key] = inputArrData?.find(item => item?.keys === '소재지동')?.values + "/" + inputArrData?.find(item => item?.keys === '소재지호')?.values;
                        } else if (x2?.key === 'mediation_option') {
                            pushData[x2?.key] = x[x2?.key] ? '공동' : '-';
                        } else {
                            pushData[x2?.key] = x[x2?.key];
                        }
                    });
                    // //console.log(pushData);
                    // pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                    // pushData['meettingcreatedt'] = x['meetings'][0]?.create_dt ? moment(x['meetings'][0]?.create_dt).format('YYYYMMDD')*1 : -1;
                    // pushData['orderprice_sell'] = x['price_all_min']*1;
                    // pushData['orderarea_private'] = x['area_private']*1;
                    // pushData['category_1'] = x['category_1']*1;
                    // pushData['category_2'] = x['category_2']*1;
                    pushData['idx'] = x['idx'] * 1;
                    // pushData['title'] = x['title'];
                    // pushData['citysData'] = x['citys'];
                    // pushData['damdangidx'] = x?.user?.idx;
                    tdlist.push(pushData);
                })
                //console.log(tdlist);
                setsaveproductlistTd(tdlist);
                setproductlistTd(tdlist);

            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            //setTimeout(() => {
            //    dispatch(loadingflas({ loading: false }));
            //}, 1000);
            //dispatch(loadingflas({ loading: false }));
        });
    }
    const popupOpen = (title, type) => {
        setpopupShow(!popupShow);
        setpopupTitle(title);
        setpopupType(type);
    }

    const kakaosenders = (senders = {}, sendertype = 0) => {
        senders.sendertype = sendertype;
        dispatch(
            open({
                component: '알림톡을 발송하시겠습니까?',
                title: '알림톡발송',
                button: "확인",
                buttonCencle: "닫기",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    let sender = senders;
                    APIS.postData('/v1/contract/kakaosenders', sender).then(({ data }) => {
                        if (data) {
                            dispatch(
                                open({
                                    component: `발송되었습니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        getlists();
                                        dispatch(close());
                                    }
                                })
                            );
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );
    }
    const contactViewer = (idxs = 0) => {
        resetUserCode(idxs, () => {
            setcontractIdx(idxs);
            setdetailwrite(true);
        })
    }
    const viewpops = (msg = '') => {
        dispatch(
            open({
                component: msg,
                title: '알림',
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }
    const alarmContent = () => {
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                <div className='main_popup_list_container'>
                    <div style={{ width: 836 }}>
                        <div className='main_popup_list_index02'>
                            <p style={{ width: 80 }}>계약번호</p>
                            <p style={{ width: 165 }}>소재지</p>
                            <p style={{ width: 64 }}>임차인명</p>
                            <p style={{ width: 56 }}>유형</p>
                            <p style={{ width: 140 }}>가격</p>
                            <p style={{ width: 64 }}>D-DAY</p>
                            <p style={{ width: 140 }}>알림톡 발송(임대)</p>
                            <p style={{ width: 140 }}>알림톡 발송(임차)</p>
                            <p style={{ width: 80, borderRight: 0 }}>삭제</p>
                        </div>

                        <div className='alarm_content_list'>
                            {contract_list?.filter(item => item?.sell_type !== '매매' && item?.status * 1 !== 99)?.map((x2, i2) => {
                                if (x2?.maindelete * 1 === 1) {
                                    return;
                                }
                                console.log(x2);
                                let inputArrData = JSON.parse(x2?.contract);
                                //console.log(inputArrData?.find(item => item?.keys === '매도인'));


                                let price1 = inputArrData?.find(item => item?.keys === '매매대금')?.values * 1;
                                let price2 = inputArrData?.find(item => item?.keys === '보증금')?.values * 1;

                                let names = inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.values[4]?.values;
                                let phone = inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.values[3]?.values;
                                let phone2 = inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.values[3]?.values;
                                let usedTxt = inputArrData?.find(item => item?.keys === '건물용도')?.values;

                                let sell_type = x2?.sell_type;//매물종류
                                let category = x2?.category;//하위
                                let ddays = Math.floor(x2?.durations);//만기디데이
                                let senders = {
                                    phone: phone?.replaceAll('-', ''), //매도
                                    phone2: phone2?.replaceAll('-', ''), //매수
                                    sell_type: sell_type,
                                    category: category,
                                    sub_category: x2?.sub_category,
                                    ddays: ddays,
                                    usedTxt: usedTxt
                                }
                                //console.log(senders, ddays);
                                //상호랑 대표번호는 정보는 user로 감지 user?.compony?.title, user?.compony?.company_phone
                                //TY_2456 임대인대상
                                //TY_2457 임차인대상
                                return (
                                    <div
                                        key={"popcontract" + i2} className='contract_alarm_list'
                                        style={{ cursor: 'pointer' }}

                                    >
                                        <div style={{ width: 80, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>{x2?.idx}</div>
                                        <div style={{ width: 165, textAlign: 'left', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>{x2?.subjects}</div>
                                        <div style={{ width: 64, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>{names}</div>
                                        <div style={{ width: 56, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>{x2?.sell_type}</div>
                                        {x2?.sell_type === '매매' &&
                                            <div style={{ width: 140, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>
                                                <div>매매가 {numFormat(price1)}만원</div>
                                            </div>
                                        }
                                        {(x2?.sell_type === '전세' || x2?.sell_type === '월세') &&
                                            <div style={{ width: 140, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>
                                                <div>보증금 {numFormat(price2)}만원</div>
                                            </div>
                                        }

                                        <div style={{ width: 64, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { contactViewer(x2?.idx); }}>{ddays * -1 < 0 ? `만기` : `D-${Math.floor(ddays * -1)}`}</div>
                                        <div style={{ width: 140 }} >
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#E1E2FC' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (senders?.phone2 === '') {
                                                        viewpops('발송할 전화번호가 없습니다.');
                                                        return;
                                                    }
                                                    kakaosenders(senders, 0);
                                                }}
                                            >
                                                <img src="./images/icons/notification.svg" width='20' />
                                            </div>
                                        </div>
                                        <div style={{ width: 140 }}>
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#E1E2FC' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (senders?.phone === '') {
                                                        viewpops('발송할 전화번호가 없습니다.');
                                                        return;
                                                    }
                                                    kakaosenders(senders, 1);
                                                }}
                                            >
                                                <img src="./images/icons/notification.svg" width='20' />
                                            </div>
                                        </div>
                                        <div style={{ width: 80 }}>
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#eee' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    dispatch(
                                                        open({
                                                            component: '삭제하시겠습니까?',
                                                            title: '삭제하기',
                                                            button: "삭제",
                                                            buttonCencle: "닫기",
                                                            titleviewer: true,
                                                            alert: false,
                                                            onPress: () => {
                                                                dispatch(loadingflas({ loading: true }));
                                                                let sender = {
                                                                    idx: x2?.idx,
                                                                    dtypes: 'main'
                                                                }
                                                                APIS.postData('/v1/contract/remove', sender).then(({ data }) => {
                                                                    if (data) {
                                                                        dispatch(
                                                                            open({
                                                                                component: `삭제되었습니다.`,
                                                                                title: '알림',
                                                                                titleviewer: true,
                                                                                alert: false,
                                                                                button: "확인",
                                                                                onPress: () => {
                                                                                    getlists();
                                                                                    dispatch(close());
                                                                                }
                                                                            })
                                                                        );
                                                                    }
                                                                }).catch(({ response }) => {
                                                                    const { data } = response;
                                                                    dispatch(
                                                                        open({
                                                                            component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                                            title: '알림',
                                                                            button: "확인",
                                                                            titleviewer: true,
                                                                            alert: false,
                                                                            onPress: () => {
                                                                                dispatch(close());
                                                                            },
                                                                        })
                                                                    );
                                                                }).finally(() => {
                                                                    dispatch(loadingflas({ loading: false }));
                                                                });
                                                            },
                                                            onCancelPress: () => {
                                                                dispatch(close());
                                                            }
                                                        })
                                                    );
                                                }}
                                            >
                                                <img src="./images/icons/trash.svg" width='20' />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                </div>
            </div>
        )
    }

    const resetUserCode = (rowIdx, callback) => {
        let findInfo = orContractList.find(v => v?.idx === rowIdx);
        console.log("findInfo", findInfo)

        if (findInfo) {
            let insertSender = {
                idx: findInfo?.idx,
                sell_type: findInfo?.sell_type,
                category: findInfo?.category,
                sub_category: findInfo?.sub_category,
            }
            if (findInfo?.contract) {
                let editContact = JSON.parse(findInfo?.contract);
                editContact = editContact?.map(v1 => {
                    if( v1?.keys === "매도인" ) {
                        return {...v1, values : v1?.values?.map(v2 =>{
                            return {...v2, values:v2?.values?.map(v3 =>{
                                if(v3?.keys === "매도인주민번호" || v3?.keys === "대리인주민번호"){
                                    return {...v3, values: v3?.values?.substr(0,6)}
                                }
                                return v3
                            })}
                        })}
                    } else if ( v1?.keys === "매수인" ) {
                        return {...v1, values : v1?.values?.map(v2 =>{
                            return {...v2, values:v2?.values?.map(v3 =>{
                                if(v3?.keys === "매수인주민번호" || v3?.keys === "대리인주민번호"){
                                    return {...v3, values: v3?.values?.substr(0,6)}
                                }
                                return v3
                            })}
                        })}
                    }
                    return v1
                })
                insertSender.contract = JSON.stringify(editContact)

                APIS.postData('/v1/contract/insert', insertSender).then(({ data }) => {
                }).catch(({ response }) => {
                }).finally(() => {
                    if (findInfo?.confirmation) {
                        let editConfirmation = JSON.parse(findInfo?.confirmation);
                        console.log("^^^^",editConfirmation)
                        editConfirmation = editContact = editContact?.map(v1 => {
                            if( v1?.keys === "매도인" ) {
                                return {...v1, values : v1?.values?.map(v2 =>{
                                    return {...v2, values:v2?.values?.map(v3 =>{
                                        if(v3?.keys === "매도인주민번호" || v3?.keys === "대리인주민번호"){
                                            return {...v3, values: v3?.values?.substr(0,6)}
                                        }
                                        return v3
                                    })}
                                })}
                            } else if ( v1?.keys === "매수인" ) {
                                return {...v1, values : v1?.values?.map(v2 =>{
                                    return {...v2, values:v2?.values?.map(v3 =>{
                                        if(v3?.keys === "매수인주민번호" || v3?.keys === "대리인주민번호"){
                                            return {...v3, values: v3?.values?.substr(0,6)}
                                        }
                                        return v3
                                    })}
                                })}
                            }
                            return v1
                        })
                        let confirmationSender = {
                            idx: findInfo?.idx,
                            confirmation: JSON.stringify(editConfirmation),
                        }
                        APIS.postData('/v1/contract/confirmationUpdate', confirmationSender).then(({ data }) => {
                        }).catch(({ response }) => {
                        }).finally(() => {
                            callback();
                        })
                    } else {
                        callback();
                    }
                })
            }else{
                callback();
            }
            
        } else {
            callback();
        }
    }
    return (
        <>
            {detailwrite === true && <Contractwrite memberinfos={memberinfos} setdetailwrite={setdetailwrite} contractIdx={contractIdx} zIndexs={1002} />}
            <Layout header={false} actives={'4'} footters={false}>
                <div
                    style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}
                    className='padding40'
                >

                    <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    >
                        <span className='bolds fontsize24'>계약</span>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                            <div className='buttons_div_box ' style={{ width: 'auto' }}>
                                <Button
                                    buttonTxt={'임대차 계약 만기 알림'}
                                    className={`searchbutton active`}
                                    styles={buttonStyle}
                                    onPress={() => {
                                        popupOpen('임대차 계약 만기 알림', 3);
                                    }}
                                />
                            </div>
                            {memberinfos?.compony && (memberinfos?.level * 1 === 2 || memberinfos?.level * 1 === 3 || memberinfos?.level * 1 === 10) &&
                                <Button
                                    onPress={() => {
                                        setcontractIdx(null);
                                        setdetailwrite(true);
                                        return;
                                        const PopComponents3 = () => {
                                            return (
                                                <div style={{ textAlign: 'left', width: '100%' }}>
                                                    <div>
                                                        매물/고객 정보에서 계약서 작성을 시작하면<br />
                                                        기본 정보를 자동으로 입력할 수 있습니다.
                                                    </div>
                                                    <div className='margint20'>
                                                        ꔷ 매물 목록 &gt; 상세보기 &gt; 계약서 작성
                                                    </div>
                                                    <div>
                                                        ꔷ 고객 목록 &gt; 상세보기 &gt; 전송매물 상세 &gt; 계약서 작성
                                                    </div>
                                                </div>
                                            );
                                        }
                                        dispatch(
                                            open({
                                                component: <PopComponents3 />,
                                                title: '계약서 작성',
                                                button: "빈 양식에 작성하기",
                                                buttonCencle: "닫기",
                                                titleviewer: true,
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(close());
                                                    setcontractIdx(null);
                                                    setdetailwrite(true);
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                },
                                            })
                                        );
                                    }}
                                    styles={{ width: 120, height: 40, fontSize: 14 }}
                                    buttonTxt={'계약서 작성'}
                                />
                            }
                        </div>
                    </div>
                    <div
                        style={{ width: '100%', height: 'calc(100% - 56px)' }}
                        className='productlistArea'
                    >
                        <div className="productlist_th">
                            {productlistTh?.length > 0 && productlistTh?.map((x, i) => {
                                return (
                                    <div
                                        key={i}
                                        style={{ minWidth: x?.winsize ? x?.winsize : 76 }}
                                    >
                                        {x?.viewernames === 'set' ?
                                            <div
                                                style={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                                                }}
                                            >
                                                <div style={{ width: 50 }}>
                                                    <Select
                                                        backgroundColors={'#F2F4F7'}
                                                        selectClass={'simpleselect'}
                                                        setValues={setselectorderby}
                                                        values={selectorderby}
                                                        selectData={([{ labels: '전체', values: '' }].concat(statusArrs))}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {(x?.viewernames === '계약일' || x?.viewernames === '중도금1' || x?.viewernames === '중도금2' || x?.viewernames === '잔금일') ?
                                                    <div
                                                        style={{
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontSize: 12
                                                        }}
                                                    >
                                                        {x?.viewernames}
                                                        <img src="./images/icons/Arrow_drop_down.svg" />
                                                    </div>
                                                    :
                                                    <div style={{ whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 12 }}>{x?.viewernames}</div>
                                                }
                                            </>
                                        }

                                    </div>
                                );
                            })}
                        </div>
                        <div className='product_scroll_list'>
                            {productlistTd?.length > 0 && productlistTd?.map((x, i) => {
                                let listClass = "";


                                return (
                                    <div className={`productlist_td`}>
                                        {productlistTh?.length > 0 && productlistTh?.map((x2, i2) => {

                                            return (
                                                <div
                                                    key={i2}
                                                    style={{ minWidth: x2?.winsize ? x2?.winsize : 76 }}
                                                >
                                                    {x2?.key === 'status' ?
                                                        <div className={`setstyles ${x[x2?.key][1]}`}>
                                                            {x[x2?.key][2] === 'y' ?
                                                                <Select
                                                                    selectClass={'simpleselect'}
                                                                    setValues={(e) => {
                                                                        let setDatas = statusArrs?.find(item => item?.idx * 1 === e * 1);
                                                                        //console.log(setDatas);

                                                                        setproductlistTd(productlistTd?.map(item => item?.idx * 1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays } : item));
                                                                        setsaveproductlistTd(saveproductlistTd?.map(item => item?.idx * 1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays } : item));

                                                                        let sender = {
                                                                            idx: x?.idx,
                                                                            status: e,
                                                                        }
                                                                        dispatch(loadingflas({ loading: true }));
                                                                        APIS.postData('/v1/contract/statusUpdate', sender).then(({ data }) => {
                                                                            if (data) {
                                                                            }
                                                                        }).catch(({ response }) => {
                                                                            const { data } = response;
                                                                            dispatch(
                                                                                open({
                                                                                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                                                    title: '알림',
                                                                                    button: "확인",
                                                                                    titleviewer: true,
                                                                                    alert: false,
                                                                                    onPress: () => {
                                                                                        dispatch(close());
                                                                                    },
                                                                                })
                                                                            );
                                                                        }).finally(() => {
                                                                            dispatch(loadingflas({ loading: false }));
                                                                        });
                                                                    }}
                                                                    values={x[x2.key][3] * 1}
                                                                    selectData={statusArrs}
                                                                />
                                                                :
                                                                x[x2?.key][0]
                                                            }
                                                        </div>
                                                        :
                                                        <>
                                                            <div
                                                                onClick={() => {
                                                                    resetUserCode(x?.idx, () => {
                                                                        setcontractIdx(x?.idx);
                                                                        setdetailwrite(true);
                                                                    })
                                                                }}
                                                                className={`${listClass}`}
                                                                style={{ cursor: 'pointer', whiteSpace: 'pre-wrap' }}
                                                            >
                                                                {x[x2?.key]}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                            {productlistTd?.length === 0 &&
                                <div className='nolistArea'>
                                    등록된 계약이 없습니다.
                                </div>
                            }
                            <div ref={target} style={{ width: '100%', height: 1 }} />
                        </div>
                    </div>
                </div>
            </Layout>
            {popupShow &&
                <MainPopup
                    title={popupTitle}
                    component={alarmContent()}
                    setClose={() => {
                        setpopupShow(!popupShow);
                    }}
                />
            }
        </>
    )
}
